import { render, staticRenderFns } from "./InspectionDetails.vue?vue&type=template&id=8ff74ce8&scoped=true&"
import script from "./InspectionDetails.vue?vue&type=script&lang=ts&"
export * from "./InspectionDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionDetails.vue?vue&type=style&index=0&id=8ff74ce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff74ce8",
  null
  
)

export default component.exports